import React from "react"
import { useTranslation } from "react-i18next"

import { TextField } from "components"
import classes from "./PopdPaymentNote.module.scss"

const PopdPaymentNote = props => {
  const {
    formErrors,
    paymentDetails,
    setPaymentDetails
  } = props

  const [t] = useTranslation()

  const handleChange = (e) => {
    const value = e.target.value

    setPaymentDetails(prev => ({
      ...prev,
      paymentNote: value
    }))
  }

  return (
    <TextField
      type="text"
      componentClass="textarea"
      maxLength={300}
      label={t("یادداشت_پرداخت")}
      className={classes["input"]}
      value={paymentDetails.paymentNote}
      onChange={handleChange}
      error={formErrors.paymentNote}
    />
  )
}

export default PopdPaymentNote